import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IUpdateFavouriteFlagQuery } from 'app/library/group/actions';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUpdateGroupMemberQuery } from '../actions';
import { ICreateGroupMemberActionPayload } from '../interfaces/create-group.action.payload.interface';
import { IGroupMemberQuery } from '../interfaces/group-member.query.interface';
import { GroupMemberCommand } from '../models/group-member.command.model';
import { GroupMember } from '../models/group-member.model';

export interface IParticipantsAndTotalCount {
    data: IGroupMemberQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
}

@Injectable()
export class GroupMemberApiService extends EntityService<IGroupMemberQuery, GroupMemberCommand> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'general/groups/groups-users');
    }

    findUsers(groupId = '', search = '', sortBy = '', sortOrder = '', pageSize = 10, pageIndex = 1): Observable<IParticipantsAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString()).set('group', groupId);

        if (search) {
            params = params.set('search', search);
        }

        if (sortBy && sortOrder) {
            switch (sortBy) {
                case 'fullName':
                    sortBy = 'firstName';
                    break;
            }

            params = params.set('sortBy', `${sortBy === 'isAdmin' ? 'gu.' + sortBy : 'u.' + sortBy}`);
            params = params.set('sortOrder', sortOrder);
        }

        return this.http.get<IParticipantsAndTotalCount>(`${this.apiUrl}/${this.entities}`, { params });
    }

    create(payload: ICreateGroupMemberActionPayload): Observable<GroupMember[]> {
        const data = {
            group: payload.group,
            users: payload.users,
        };

        return this.http.post<IGroupMemberQuery[]>(`${this.apiUrl}/groups/groups-users`, data).pipe(map((queries) => queries.map((query) => new GroupMember(query))));
    }

    update(payload: IUpdateGroupMemberQuery): Observable<GroupMember> {
        return this.http
            .patch<IGroupMemberQuery>(`${this.apiUrl}/groups/groups-users/${payload.memberId}`, {
                is_admin: payload.isAdmin,
            })
            .pipe(map((query) => new GroupMember(query)));
    }

    updateFavouriteFlag(payload: IUpdateFavouriteFlagQuery): Observable<GroupMember> {
        return this.http
            .patch<IGroupMemberQuery>(`${this.apiUrl}/groups/${payload.groupId}/is-favourite`, {
                is_favourite: payload.isFavourite,
            })
            .pipe(map((query) => new GroupMember(query)));
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/groups/groups-users/${id}`);
    }
}
